// Mock data for EXIT88 LIVE platform
// BUILD: 2025-12-30T20:00:00Z

// Debug UI utility - allows forcing livestream status via localStorage OR URL param ?debug=1
export const getDebugUI = () => {
  if (typeof window !== 'undefined') {
    // Check URL param first
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('debug') === '1') {
      localStorage.setItem('DEBUG_UI', '1');
      return true;
    }
    return localStorage.getItem('DEBUG_UI') === '1';
  }
  return false;
};

// Helper to calculate dynamic event start times for testing
const now = new Date();
const in48Hours = new Date(now.getTime() + 48 * 60 * 60 * 1000);
const in10Minutes = new Date(now.getTime() + 10 * 60 * 1000);

// Helper to get livestream status from time
export const getLivestreamStatus = (startDate, endDate, forcedStatus = null) => {
  if (forcedStatus) return forcedStatus;
  const nowTime = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  if (nowTime < start) return 'UPCOMING';
  if (nowTime >= start && nowTime <= end) return 'LIVE';
  return 'ENDED';
};

export const mockUser = {
  id: 'user-001',
  name: 'Daniel U.',
  firstName: 'Daniel',
  lastName: 'Umoren',
  email: 'daniel@example.com',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
  dateOfBirth: '1990-05-15',
  bio: 'Music enthusiast and live event lover. Always looking for the next great concert experience.',
  gender: 'Male',
  location: 'New York, NY',
  isLoggedIn: false
};

export const mockEvents = [
  {
    id: 'evt-001',
    title: 'No Sign of Weakness',
    description: 'An electrifying night of rock music featuring the hottest bands in the scene.',
    date: '2026-01-15T20:00:00Z',
    endDate: '2026-01-16T02:00:00Z',
    venue: 'Madison Square Garden',
    city: 'New York, NY',
    address: '4 Pennsylvania Plaza, New York, NY 10001',
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1200&q=80',
    status: 'upcoming',
    adminStatus: 'not_started',
    livestreamEnabled: true,
    livestreamStatus: 'UPCOMING',
    ticketTypes: [
      { id: 'tt-001', name: 'General Admission', price: 50, available: 500 },
      { id: 'tt-002', name: 'VIP', price: 150, available: 100 },
      { id: 'tt-003', name: 'Livestream', price: 25, available: 1000 }
    ],
    artists: [
      { id: 'art-001', name: 'The Midnight', image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&q=80', instrument: 'Synthwave' },
      { id: 'art-002', name: 'Gunship', image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=200&q=80', instrument: 'Electronic' },
      { id: 'art-003', name: 'FM-84', image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=200&q=80', instrument: 'Retrowave' },
      { id: 'art-004', name: 'Timecop1983', image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=200&q=80', instrument: 'Synthwave' }
    ],
    totalRevenue: 125000,
    ticketsSold: 450,
    checkIns: 0,
    views: 12500,
    streamConfig: {
      streamName: 'No Sign of Weakness - Live',
      latencyMode: 'low',
      dvrWindow: 30,
      playbackPolicy: 'public',
      autoRecord: true,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_nsow_2026_abc123xyz',
      playbackUrl: 'https://stream.exit88.com/nsow-2026',
      streamStatus: 'inactive'
    }
  },
  {
    id: 'evt-002',
    title: 'Summer Vibes Festival',
    description: 'Three days of non-stop electronic music under the summer sun.',
    date: '2026-03-20T14:00:00Z',
    endDate: '2026-03-22T23:00:00Z',
    venue: 'Coachella Valley',
    city: 'Indio, CA',
    address: '81800 51st Ave, Indio, CA 92201',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=1200&q=80',
    status: 'upcoming',
    adminStatus: 'not_started',
    livestreamEnabled: true,
    livestreamStatus: 'UPCOMING',
    ticketTypes: [
      { id: 'tt-004', name: '3-Day Pass', price: 299, available: 2000 },
      { id: 'tt-005', name: 'VIP 3-Day Pass', price: 599, available: 500 },
      { id: 'tt-006', name: 'Livestream Pass', price: 49, available: 5000 }
    ],
    artists: [
      { id: 'art-005', name: 'Deadmau5', image: 'https://images.unsplash.com/photo-1571266028243-e4733b0f0bb0?w=200&q=80', instrument: 'Electronic' },
      { id: 'art-006', name: 'Marshmello', image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=200&q=80', instrument: 'EDM' }
    ],
    totalRevenue: 0,
    ticketsSold: 0,
    checkIns: 0,
    views: 8500,
    streamConfig: {
      streamName: 'Summer Vibes Festival - Day 1',
      latencyMode: 'normal',
      dvrWindow: 60,
      playbackPolicy: 'public',
      autoRecord: true,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_svf_2026_def456uvw',
      playbackUrl: 'https://stream.exit88.com/svf-2026',
      streamStatus: 'inactive'
    }
  },
  {
    id: 'evt-003',
    title: 'Coldplay Live',
    description: 'An intimate evening with Coldplay.',
    date: '2024-11-15T19:00:00Z',
    endDate: '2024-11-15T23:00:00Z',
    venue: 'Hollywood Bowl',
    city: 'Los Angeles, CA',
    address: '2301 N Highland Ave, Los Angeles, CA 90068',
    image: 'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=1200&q=80',
    status: 'past',
    adminStatus: 'done',
    livestreamEnabled: true,
    livestreamStatus: 'ENDED',
    hasRecap: true,
    recapUrl: 'https://example.com/recap/evt-003',
    ticketTypes: [
      { id: 'tt-007', name: 'Standard', price: 75, available: 0 },
      { id: 'tt-008', name: 'Premium', price: 125, available: 0 }
    ],
    artists: [
      { id: 'art-007', name: 'Coldplay', image: 'https://images.unsplash.com/photo-1485579149621-3123dd979885?w=200&q=80', instrument: 'Rock' }
    ],
    totalRevenue: 45000,
    ticketsSold: 600,
    checkIns: 580,
    views: 3200,
    streamConfig: {
      streamName: 'Coldplay Live - Hollywood Bowl',
      latencyMode: 'low',
      dvrWindow: 30,
      playbackPolicy: 'public',
      autoRecord: true,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_coldplay_2024_ghi789rst',
      playbackUrl: 'https://stream.exit88.com/coldplay-2024',
      streamStatus: 'inactive'
    }
  },
  {
    id: 'evt-004',
    title: 'World of Walker',
    description: 'A tribute to Alan Walker with amazing DJ performances.',
    date: '2024-12-15T20:00:00Z',
    endDate: '2024-12-16T01:00:00Z',
    venue: 'The Forum',
    city: 'Inglewood, CA',
    address: '3900 W Manchester Blvd, Inglewood, CA 90305',
    image: 'https://images.unsplash.com/photo-1498038432885-c6f3f1b912ee?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=1200&q=80',
    status: 'past',
    adminStatus: 'done',
    livestreamEnabled: true,
    livestreamStatus: 'ENDED',
    hasRecap: true,
    ticketTypes: [
      { id: 'tt-009', name: 'Floor', price: 100, available: 0 },
      { id: 'tt-010', name: 'Balcony', price: 60, available: 0 }
    ],
    artists: [
      { id: 'art-008', name: 'Alan Walker', image: 'https://images.unsplash.com/photo-1508854710579-5cecc3a9ff17?w=200&q=80', instrument: 'EDM' }
    ],
    totalRevenue: 85000,
    ticketsSold: 1200,
    checkIns: 1150,
    views: 5600,
    streamConfig: {
      streamName: 'World of Walker - The Forum',
      latencyMode: 'low',
      dvrWindow: 30,
      playbackPolicy: 'public',
      autoRecord: false,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_walker_2024_jkl012mno',
      playbackUrl: 'https://stream.exit88.com/walker-2024',
      streamStatus: 'inactive'
    }
  },
  // EVENT A: 48 hours from now - for extended countdown testing
  {
    id: 'evt-005',
    title: 'Neon Dreams Tour',
    description: 'Experience the future of electronic music with cutting-edge visuals.',
    date: in48Hours.toISOString(),
    endDate: new Date(in48Hours.getTime() + 6 * 60 * 60 * 1000).toISOString(),
    venue: 'Barclays Center',
    city: 'Brooklyn, NY',
    address: '620 Atlantic Ave, Brooklyn, NY 11217',
    image: 'https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1200&q=80',
    status: 'upcoming',
    adminStatus: 'not_started',
    livestreamEnabled: true,
    livestreamStatus: 'UPCOMING',
    ticketTypes: [
      { id: 'tt-011', name: 'General Admission', price: 85, available: 300 },
      { id: 'tt-012', name: 'VIP Experience', price: 250, available: 50 },
      { id: 'tt-013', name: 'Livestream', price: 35, available: 2000 }
    ],
    artists: [
      { id: 'art-001', name: 'The Midnight', image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&q=80', instrument: 'Synthwave' },
      { id: 'art-004', name: 'Timecop1983', image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=200&q=80', instrument: 'Synthwave' }
    ],
    totalRevenue: 45000,
    ticketsSold: 350,
    checkIns: 0,
    views: 9800,
    streamConfig: {
      streamName: 'Neon Dreams Tour - NYE Special',
      latencyMode: 'low',
      dvrWindow: 45,
      playbackPolicy: 'signed',
      autoRecord: true,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_neon_2025_pqr345stu',
      playbackUrl: 'https://stream.exit88.com/neon-2025',
      streamStatus: 'inactive'
    }
  },
  // EVENT B: 10 minutes from now - for quick LIVE testing
  {
    id: 'evt-006',
    title: 'Synthwave Sunset',
    description: 'A quick livestream session featuring the best of synthwave.',
    date: in10Minutes.toISOString(),
    endDate: new Date(in10Minutes.getTime() + 2 * 60 * 60 * 1000).toISOString(),
    venue: 'Online Only',
    city: 'Virtual',
    address: 'Livestream Event',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80',
    coverImage: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=1200&q=80',
    status: 'upcoming',
    adminStatus: 'in_progress',
    livestreamEnabled: true,
    livestreamStatus: 'UPCOMING',
    ticketTypes: [
      { id: 'tt-014', name: 'Livestream Access', price: 15, available: 5000 }
    ],
    artists: [
      { id: 'art-001', name: 'The Midnight', image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&q=80', instrument: 'Synthwave' },
      { id: 'art-002', name: 'Gunship', image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=200&q=80', instrument: 'Electronic' }
    ],
    totalRevenue: 12500,
    ticketsSold: 834,
    checkIns: 0,
    views: 4200,
    streamConfig: {
      streamName: 'Synthwave Sunset - Quick Session',
      latencyMode: 'low',
      dvrWindow: 30,
      playbackPolicy: 'public',
      autoRecord: true,
      ingestUrl: 'rtmp://live.exit88.com/ingest',
      streamKey: 'sk_live_sunset_quick_xyz789',
      playbackUrl: 'https://stream.exit88.com/sunset-quick',
      streamStatus: 'inactive'
    }
  }
];

// Artists with multiple tip/payment links (4 fields: paypal, venmo, cashApp, customTip)
// These URLs are admin-controlled - users cannot modify them
export const mockArtists = [
  { 
    id: 'art-001', 
    name: 'The Midnight', 
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&q=80', 
    instrument: 'Synthwave', 
    totalPerformances: 45, 
    lastEvent: '2025-01-10', 
    website: 'https://themidnight.com', 
    bio: 'The Midnight is a synthwave duo from Los Angeles.',
    tipLinks: {
      paypal: 'https://paypal.me/themidnight',
      venmo: 'https://venmo.com/u/themidnight',
      cashApp: 'https://cash.app/$TheMidnight',
      customTip: 'https://patreon.com/themidnight'
    }
  },
  { 
    id: 'art-002', 
    name: 'Gunship', 
    image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=200&q=80', 
    instrument: 'Electronic', 
    totalPerformances: 32, 
    lastEvent: '2025-01-05', 
    website: 'https://gunship.com', 
    bio: 'British synthwave band formed in 2014.',
    tipLinks: {
      paypal: 'https://paypal.me/gunshipmusic',
      venmo: 'https://venmo.com/u/gunshipmusic',
      cashApp: '',
      customTip: ''
    }
  },
  { 
    id: 'art-003', 
    name: 'FM-84', 
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=200&q=80', 
    instrument: 'Retrowave', 
    totalPerformances: 28, 
    lastEvent: '2024-12-20', 
    website: '', 
    bio: 'Col Bennett, better known by his stage name FM-84.',
    tipLinks: {
      paypal: '',
      venmo: '',
      cashApp: 'https://cash.app/$FM84Music',
      customTip: 'https://ko-fi.com/fm84'
    }
  },
  { 
    id: 'art-004', 
    name: 'Timecop1983', 
    image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=200&q=80', 
    instrument: 'Synthwave', 
    totalPerformances: 52, 
    lastEvent: '2025-01-08', 
    website: 'https://timecop1983.com', 
    bio: 'Dutch synthwave producer creating nostalgic 80s sounds.',
    tipLinks: {
      paypal: 'https://paypal.me/timecop1983',
      venmo: 'https://venmo.com/u/timecop1983',
      cashApp: 'https://cash.app/$Timecop1983',
      customTip: 'https://ko-fi.com/timecop1983'
    }
  },
  { 
    id: 'art-005', 
    name: 'Deadmau5', 
    image: 'https://images.unsplash.com/photo-1571266028243-e4733b0f0bb0?w=200&q=80', 
    instrument: 'Electronic', 
    totalPerformances: 120, 
    lastEvent: '2025-01-12', 
    website: 'https://deadmau5.com', 
    bio: 'Canadian electronic music producer and DJ.',
    tipLinks: {
      paypal: '',
      venmo: '',
      cashApp: '',
      customTip: ''
    }
  },
  { 
    id: 'art-006', 
    name: 'Marshmello', 
    image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=200&q=80', 
    instrument: 'EDM', 
    totalPerformances: 89, 
    lastEvent: '2025-01-15', 
    website: 'https://marshmello.com', 
    bio: 'American electronic music producer and DJ.',
    tipLinks: {
      paypal: '',
      venmo: 'https://venmo.com/u/marshmello',
      cashApp: 'https://cash.app/$Marshmello',
      customTip: ''
    }
  }
];

export const mockDrafts = [
  { id: 'draft-001', title: 'Untitled Event', lastModified: '2025-01-05T14:30:00Z', step: 'basics' },
  { id: 'draft-002', title: 'Spring Music Festival', lastModified: '2025-01-04T10:15:00Z', step: 'media' }
];

export const mockCustomers = [
  { id: 'cust-001', name: 'John Smith', email: 'john@example.com', totalSpent: 450, ticketsPurchased: 5, lastPurchase: '2025-01-02' },
  { id: 'cust-002', name: 'Sarah Johnson', email: 'sarah@example.com', totalSpent: 850, ticketsPurchased: 8, lastPurchase: '2025-01-05' },
  { id: 'cust-003', name: 'Mike Wilson', email: 'mike@example.com', totalSpent: 225, ticketsPurchased: 3, lastPurchase: '2024-12-28' },
  { id: 'cust-004', name: 'Emily Davis', email: 'emily@example.com', totalSpent: 1200, ticketsPurchased: 12, lastPurchase: '2025-01-06' },
  { id: 'cust-005', name: 'Chris Brown', email: 'chris@example.com', totalSpent: 375, ticketsPurchased: 4, lastPurchase: '2024-12-20' }
];

export const mockCampaigns = [
  { id: 'camp-001', name: 'Early Bird Special', status: 'active', type: 'email', sent: 5000, opened: 2500, clicked: 800, conversions: 150, revenue: 7500 },
  { id: 'camp-002', name: 'VIP Exclusive Offer', status: 'completed', type: 'email', sent: 1000, opened: 750, clicked: 300, conversions: 75, revenue: 11250 }
];

// Updated tickets with livestream-enabled events
export const mockTickets = [
  {
    id: 'tkt-001',
    eventId: 'evt-001',
    eventTitle: 'No Sign of Weakness',
    eventDate: '2026-01-15T20:00:00Z',
    eventImage: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800&q=80',
    ticketType: 'In-Person',
    ticketTypeName: 'VIP',
    price: 150,
    quantity: 2,
    purchaseDate: '2025-12-20T10:30:00Z',
    transactionId: '2947583920',
    qrCode: 'E88-TKT-001-VIP-2026',
    venue: 'Madison Square Garden',
    city: 'New York, NY',
    purchasedBy: 'Franklin Benjamin'
  },
  {
    id: 'tkt-002',
    eventId: 'evt-005',
    eventTitle: 'Neon Dreams Tour',
    eventDate: in48Hours.toISOString(),
    eventImage: 'https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?w=800&q=80',
    ticketType: 'Livestream',
    ticketTypeName: 'Livestream Access',
    price: 35,
    quantity: 1,
    purchaseDate: '2025-12-22T15:45:00Z',
    transactionId: '2947583921',
    qrCode: null,
    venue: 'Online Stream',
    city: 'Virtual',
    purchasedBy: 'Franklin Benjamin'
  },
  {
    id: 'tkt-003',
    eventId: 'evt-006',
    eventTitle: 'Synthwave Sunset',
    eventDate: in10Minutes.toISOString(),
    eventImage: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80',
    ticketType: 'Livestream',
    ticketTypeName: 'Livestream Access',
    price: 15,
    quantity: 1,
    purchaseDate: '2025-12-28T09:00:00Z',
    transactionId: '2947583922',
    qrCode: null,
    venue: 'Online Stream',
    city: 'Virtual',
    purchasedBy: 'Franklin Benjamin'
  },
  {
    id: 'tkt-004',
    eventId: 'evt-002',
    eventTitle: 'Summer Vibes Festival',
    eventDate: '2026-03-20T14:00:00Z',
    eventImage: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&q=80',
    ticketType: 'Livestream',
    ticketTypeName: 'Livestream Pass',
    price: 49,
    quantity: 1,
    purchaseDate: '2025-12-22T15:45:00Z',
    transactionId: '2947583923',
    qrCode: null,
    venue: 'Online Stream',
    city: 'Virtual',
    purchasedBy: 'Franklin Benjamin'
  }
];

export const mockWishlist = [mockEvents[0], mockEvents[1]];

export const mockStreamLogs = [
  { id: 1, timestamp: '2025-01-06T20:00:15Z', type: 'info', message: 'Stream started' },
  { id: 2, timestamp: '2025-01-06T20:05:30Z', type: 'info', message: 'Viewer count: 1,250' },
  { id: 3, timestamp: '2025-01-06T20:10:45Z', type: 'warning', message: 'Bitrate fluctuation detected' },
  { id: 4, timestamp: '2025-01-06T20:15:00Z', type: 'info', message: 'Viewer count: 2,500' },
  { id: 5, timestamp: '2025-01-06T20:20:15Z', type: 'info', message: 'Stream quality: Excellent' }
];

export const mockScanLogs = [
  { id: 1, timestamp: '2025-01-06T19:30:00Z', ticketId: 'TKT-001', name: 'John Smith', status: 'valid' },
  { id: 2, timestamp: '2025-01-06T19:31:15Z', ticketId: 'TKT-002', name: 'Sarah Johnson', status: 'valid' },
  { id: 3, timestamp: '2025-01-06T19:32:30Z', ticketId: 'TKT-003', name: 'Unknown', status: 'invalid' },
  { id: 4, timestamp: '2025-01-06T19:33:45Z', ticketId: 'TKT-004', name: 'Mike Wilson', status: 'valid' },
  { id: 5, timestamp: '2025-01-06T19:35:00Z', ticketId: 'TKT-005', name: 'Emily Davis', status: 'already_scanned' }
];

export const mockAnalytics = {
  ticketsSold: 748,
  revenue: 5500000,
  uniqueViewers: 982,
  peakConcurrency: 314,
  watchTime: '10h 25m',
  chatCount: 367,
  tips: 2285000,
  sponsorImpressions: 11023
};

// Chat messages per event for livestream testing
export const mockEventChatMessages = {
  'evt-005': [
    { id: 'msg-001', userId: 'user-101', userName: 'MusicFan92', avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50', message: 'This is incredible! 🔥🔥', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-002', userId: 'user-102', userName: 'SynthLover', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50', message: 'The light show is amazing tonight', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-003', userId: 'user-103', userName: 'NightOwl23', avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=50', message: 'Best concert I\'ve watched online!', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-004', userId: 'user-104', userName: 'TrollUser666', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50', message: 'This sucks lol', timestamp: new Date().toISOString(), isBlocked: false, isProblemUser: true },
    { id: 'msg-005', userId: 'user-105', userName: 'BeatsDropper', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50', message: 'YOOO that drop was INSANE 💯', timestamp: new Date().toISOString(), isBlocked: false },
  ],
  'evt-006': [
    { id: 'msg-101', userId: 'user-201', userName: 'RetroWaveKing', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50', message: 'Starting in a few minutes! 🎉', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-102', userId: 'user-202', userName: 'ConcertGoer', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50', message: 'Watching from Tokyo! 🇯🇵', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-103', userId: 'user-203', userName: 'VinylCollector', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50', message: 'The sound quality is perfect 🎧', timestamp: new Date().toISOString(), isBlocked: false },
    { id: 'msg-104', userId: 'user-204', userName: 'SpamBot99', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=50', message: 'Buy crypto at scam.com!', timestamp: new Date().toISOString(), isBlocked: false, isProblemUser: true },
    { id: 'msg-105', userId: 'user-205', userName: 'NeonVibes', avatar: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=50', message: 'First livestream purchase ever, no regrets!', timestamp: new Date().toISOString(), isBlocked: false },
  ]
};

// Legacy chat messages for admin monitor
export const mockChatMessages = mockEventChatMessages['evt-005'];

// Tip history per event
export const mockTipHistory = {
  'evt-005': [
    { id: 'tip-001', fromUserId: 'user-101', fromUserName: 'MusicFan92', toArtistId: 'art-001', toArtistName: 'The Midnight', amount: 25, method: 'venmo', timestamp: new Date().toISOString(), message: 'Amazing performance!' },
    { id: 'tip-002', fromUserId: 'user-102', fromUserName: 'SynthLover', toArtistId: 'art-004', toArtistName: 'Timecop1983', amount: 10, method: 'cashApp', timestamp: new Date().toISOString(), message: 'Love your music!' },
    { id: 'tip-003', fromUserId: 'user-105', fromUserName: 'BeatsDropper', toArtistId: 'art-001', toArtistName: 'The Midnight', amount: 50, method: 'card', timestamp: new Date().toISOString(), message: '🔥🔥🔥' },
  ],
  'evt-006': [
    { id: 'tip-101', fromUserId: 'user-201', fromUserName: 'RetroWaveKing', toArtistId: 'art-001', toArtistName: 'The Midnight', amount: 15, method: 'paypal', timestamp: new Date().toISOString(), message: 'Thanks for the show!' },
    { id: 'tip-102', fromUserId: 'user-205', fromUserName: 'NeonVibes', toArtistId: 'art-002', toArtistName: 'Gunship', amount: 20, method: 'venmo', timestamp: new Date().toISOString(), message: 'Epic!' },
  ]
};

// Live stats for monitoring
export const mockLiveStats = {
  currentViewers: 2547,
  peakViewers: 3842,
  totalTips: 3200,
  ticketsCheckedIn: 125
};

// Payment methods available
export const paymentMethods = [
  { id: 'venmo', name: 'Venmo', color: '#3D95CE', textColor: 'white', icon: 'venmo' },
  { id: 'cashApp', name: 'Cash App', color: '#00D632', textColor: 'white', icon: 'cashApp' },
  { id: 'paypal', name: 'PayPal', color: '#003087', textColor: 'white', icon: 'paypal' },
  { id: 'buyMeACoffee', name: 'Buy me a coffee', color: '#FFDD00', textColor: 'black', icon: 'coffee' },
  { id: 'card', name: 'Tip with Card', color: 'transparent', textColor: '#00C8C8', icon: 'card', isOutline: true }
];

// Admin user mock
export const mockAdminUser = {
  id: 'admin-001',
  name: 'Admin User',
  firstName: 'Admin',
  lastName: 'User',
  email: 'admin@exit88.live',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80',
  dateOfBirth: '1985-01-01',
  bio: 'Platform administrator',
  gender: 'Male',
  location: 'New York, NY',
  isLoggedIn: true,
  roles: [{ role: 'admin', eventId: null }],
  effectiveRole: 'admin'
};

// Event details lookup (maps event IDs to full event objects)
export const mockEventDetails = mockEvents.reduce((acc, event) => {
  acc[event.id] = event;
  return acc;
}, {});
